import React, { useContext, useEffect } from 'react';
import { useParams } from 'react-router';
import { PageContext, useApiWithErrors } from '@axiom/ui';

import { ExpiredLink } from '../ExpiredLink/ExpiredLink';
import { ClientResetPassword } from '../ClientResetPassword/ClientResetPassword';
import { AuthResetsApi } from '../../api/auth-resets-api';

export const SetPassword = () => {
  const { setTitle } = useContext(PageContext);
  const { token, providedEmail } = useParams();
  const [response] = useApiWithErrors(
    token ? AuthResetsApi.readToken(token) : undefined
  );
  const tokenIsValid = token && response?.data !== undefined;

  useEffect(() => {
    setTitle('Axiom Law - Login');
  }, [setTitle]);

  return tokenIsValid && providedEmail ? (
    <div data-test="SET_PASSWORD_VALID">
      <ClientResetPassword
        name="CLIENT_RESET_PASSWORD"
        token={token}
        email={providedEmail}
        mfaCodeRequired={response.data.mfaCodeRequired}
      />
    </div>
  ) : (
    <div data-test="SET_PASSWORD_EXPIRED">
      <ExpiredLink />
    </div>
  );
};
